/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { Injectable }            from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { User       }            from '@/models/user';
import { AuthenticationService } from "@/services/authentication.service";
import {ISubdivisionRow} from "@/screens/administration/i.subdivision.row";


@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class SubdivisionService
 *
 * @brief CRUD access to subdivision models
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class SubdivisionService {

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {


  }

  /** fetch the list of subdivisions */
  getAll() {

    return this.http.get<ISubdivisionRow[]>(`/backend/subdivisions/all`);
  }

  /** find a specific subdivision (by OID) */
  getById(id: number) {

    return this.http.get(`/backend/subdivisions/list/${id}`);
  }

  /** fetch any headers we need to send along with our request */
  headers(): HttpHeaders {

    const user: User = this.auth.userOfSession;

    if (!user) {

      /* no user logged in */

      return null;
    }

    return new HttpHeaders().set('Authorization', user.token).set('Content-Type', 'application/json');
  }

  /** helper to just get a simple CSV style dump */
  dump(subid: string = '') {

    if (subid.length != 0) {

      return this.http.get(`/backend/report/subdivisiondump/${subid}`);
    }

    return this.http.get(`/backend/report/subdivisiondump`);
  }

  /** delete a subdivision, we don't actually delete, we just mark as deleted. */
  deleteSubdivision(subid: number|string) {

    const upd: ISubdivisionRow = {
      is_deleted: true
    };

    return this.update(subid, upd);
  }

  /** undelete a subdivision */
  undeleteSubdivision(subid: number|string) {

    const upd: ISubdivisionRow = {
      is_deleted: false
    };

    return this.update(subid, upd);
  }

  /** update a subdivision */
  update(subid: number|string, data: ISubdivisionRow) {

    const headers = this.headers();

    if (!headers) {

      return null;
    }

    return this.http.post(`/backend/subdivisions/edit/${subid}`, data, {
      headers
    });
  }

  /** create a subdivision */
  create(data: ISubdivisionRow) {

    const headers = this.headers();

    if (!headers) {

      return null;
    }

    return this.http.post(`/backend/subdivisions/create`, data, {
      headers
    });
  }

}
